import { schema } from '../models/biologySchema';

const name = (inputValue) => {
  if (!inputValue) return inputValue;

  for (const phylum of schema) {
    for (const classes of phylum.class || []) {
      for (const order of classes.order || []) {
        for (const genus of order.genus || []) {
          for (const species of genus.species || []) {
            if (species.commonName === inputValue || species.scientificName === inputValue) {
              return `${species.commonName} (${species.scientificName})`;
            }
          }
        }
      }
    }
  }

  return inputValue;
};

export { name };
